import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom-v5-compat';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { SellerFeatures } from '../../../../../../enums/seller-features';
import { useIsSellerOnFeatureGatedPlan } from '../../../../../../feature-gates/use-is-seller-on-feature-gated-plan';
import { useIsSellerFeatureEnabled } from '../../../../../../hooks/use-is-seller-feature-enabled';
import { getSubscriptionPath, getInventorySyncSettingPath, getAddonMarketplacePath } from '../../../../../../routes/constants';
import { messages } from '../messages';

/**
 * Button component that shows different actions based on user's plan profile and inventory sync access
 * @param {object} props
 * @param {string} props.className - CSS class name for the button
 * @returns {React.JSX.Element}
 */
export const SyncActionButton = ({ className }) => {
  const navigate = useNavigate();
  const isOnGoodBetterBestPlanProfile = useIsSellerOnFeatureGatedPlan();
  const isInventorySyncEnabled = useIsSellerFeatureEnabled(SellerFeatures.InventorySync);

  // Take user to subscription page if they are on Good/Better/Best plan profile without access
  const handleUpgradePlanClick = useCallback(
    (event) => {
      event.preventDefault();
      navigate(getSubscriptionPath());
    },
    [navigate],
  );

  // Take user to inventory sync settings page if they have access
  const handleConfigureNowClick = useCallback(
    (event) => {
      event.preventDefault();
      navigate(getInventorySyncSettingPath());
    },
    [navigate],
  );

  // Take user to add-on marketplace if on older plan profiles
  const handleTryNowClick = useCallback(
    (event) => {
      event.preventDefault();
      navigate(getAddonMarketplacePath());
    },
    [navigate],
  );

  let onClick = handleTryNowClick;
  let message = messages.tryNow;

  if (isOnGoodBetterBestPlanProfile && isInventorySyncEnabled) {
    onClick = handleConfigureNowClick;
    message = messages.configureNow;
  } else if (isOnGoodBetterBestPlanProfile) {
    onClick = handleUpgradePlanClick;
    message = messages.upgradePlan;
  }

  return (
    <Button className={className} onClick={onClick} theme={THEME_CONSTANTS.primary}>
      <FormattedMessage {...message} />
    </Button>
  );
};
